import { makeObservable, observable, action, runInAction } from "mobx";
import { apiFetch } from "../config/api";

class LicensesStore {
  licenses = [];
  specificLicense = {};

  isLoadingLicenses = false;
  isLoadingSpecificLicense = false;

  constructor() {
    makeObservable(this, {
      licenses: observable.ref,
      isLoadingLicenses: observable.ref,
      specificLicense: observable.ref,
      isLoadingSpecificLicense: observable.ref,

      getLicenses: action,
      getSpecificLicense: action,
      createLicense: action,
      deleteLicense: action,
      updateLicense: action,
    });
  }

  getLicenses = () => {
    runInAction(() => {
      this.isLoadingLicenses = true;
    });
    apiFetch("api/licenses/")
      .then(({ data }) => {
        runInAction(() => {
          this.licenses = data;
          this.isLoadingLicenses = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingLicenses = false;
        });
      });
  };

  getSpecificLicense = (id) => {
    runInAction(() => {
      this.isLoadingSpecificLicense = true;
    });
    apiFetch(`api/licenses/${id}/`)
      .then(({ data }) => {
        runInAction(() => {
          this.specificLicense = data;
          this.isLoadingSpecificLicense = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingSpecificLicense = false;
        });
      });
  };

  createLicense = ({ payload, callback }) => {
    runInAction(() => {
      this.isLoadingLicenses = true;
    });
    apiFetch("api/licenses/", {
      method: "POST",
      body: payload,
    })
      .then(({ data }) => {
        runInAction(() => {
          const newLicenses = [...this.licenses, data];
          this.licenses = newLicenses;
          callback && callback();
          this.isLoadingLicenses = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingLicenses = false;
        });
      });
  };

  deleteLicense = ({ id, callback }) => {
    runInAction(() => {
      this.isLoadingLicenses = true;
    });
    apiFetch(`api/licenses/${id}/`, {
      method: "DELETE",
    })
      .then(() => {
        runInAction(() => {
          const newLicenses = this.licenses.filter((el) => el.id !== id);
          this.licenses = newLicenses;
          callback && callback();
          this.isLoadingLicenses = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingLicenses = false;
        });
      });
  };

  updateLicense = ({ id, payload }) => {
    runInAction(() => {
      this.isLoadingSpecificLicense = true;
    });
    apiFetch(`api/licenses/${id}/`, {
      method: "PUT",
      body: payload,
    })
      .then(({ data }) => {
        runInAction(() => {
          this.specificLicense = data;
          this.isLoadingSpecificLicense = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingSpecificLicense = false;
        });
      });
  };
}

export default new LicensesStore();
